<template>
    <sys-register-base 
        :loading="loading" 
        @onSave="save" 
        :model.sync="localModel" 
        :title="title" 
        :icon="icon"
        v-bind:show.sync="dialog"
        maxWidth="50%"
    >
        <template v-slot:tools>
            <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                    <v-menu
                        v-model="viewMenu"
                        offset-x
                        offset-y
                        bottom
                        :close-on-content-click="false"
                        v-bind="attrs"
                        v-on="on"
                    >
                        <template v-slot:activator="{ on: onMenu, attrs: attrsMenu }">
                            <v-btn
                                fab
                                color="primary"
                                x-small
                                v-bind="attrsMenu"
                                v-on="{ ...on, ...onMenu }"
                            >
                                <v-icon small>mdi-tag-plus-outline</v-icon>
                            </v-btn>
                        </template>
                        <v-list dense class="py-0">
                            <v-subheader class="caption font-weight-bold">Conteúdo do termo</v-subheader>
                            <emc-util-scroll maxHeight="200px">
                                <v-list-item
                                    v-for="(tag, i) in tags"
                                    :key="'content-' + i"
                                    link
                                    @click="setField(tag)"
                                >
                                    <v-list-item-content>
                                        <v-list-item-title class="text-body-2">{{ tag.tag }}</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </emc-util-scroll>
                            <v-divider v-if="localModel && localModel.send_email" />
                            <v-subheader v-if="localModel && localModel.send_email" class="caption font-weight-bold">Corpo do e-mail</v-subheader>
                            <template v-if="localModel && localModel.send_email">
                                <v-list-item
                                    v-for="(tag, i) in emailTags"
                                    :key="'email-' + i"
                                    link
                                    @click="setEmailField(tag)"
                                >
                                    <v-list-item-content>
                                        <v-list-item-title class="text-body-2">{{ tag.tag }}</v-list-item-title>
                                        <v-list-item-subtitle class="caption">{{ tag.description }}</v-list-item-subtitle>
                                    </v-list-item-content>
                                </v-list-item>
                            </template>
                        </v-list>
                    </v-menu>
                </template>
                <span>Inserir tag — Ctrl+Shift+T</span>
            </v-tooltip>
        </template>
    
        <template v-slot:form>
            <v-container>
                    <v-row>
                        <v-col cols="12" sm="8">
                            <v-text-field
                                autofocus
                                v-model="localModel.name"
                                label="Nome*"
                                :error="!!errors.name"
                                :error-messages="errors.name"
                                :counter="255"
                            />
                        </v-col>
                        <v-col cols="12" sm="4">
                            <s-text-field code :error-messages="errors.code" v-model="localModel.code" label="Código"/>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" sm="12">
                            <v-textarea
                                v-model="localModel.description"
                                label="Descrição*"
                                :error="!!errors.description"
                                :error-messages="errors.description"
                                :counter="255"
                                rows="2"
                                outlined
                            />
                        </v-col>
                    </v-row>
                    <!-- RN01: Múltiplas Opções de Resposta -->
                    <v-row>
                        <v-col cols="12">
                            <v-divider class="my-3"></v-divider>
                            <v-card flat class="grey lighten-5 pa-3 rounded">
                                <div class="d-flex align-center justify-space-between mb-3">
                                    <div>
                                        <span class="subtitle-1 font-weight-medium">
                                            <v-icon color="primary" class="mr-2">mdi-format-list-checks</v-icon>
                                            Opções de Resposta
                                        </span>
                                        <div class="caption grey--text mt-1">
                                            Defina as opções que o usuário poderá escolher ao responder este termo
                                        </div>
                                    </div>
                                    <v-btn 
                                        small 
                                        color="primary"
                                        @click="addTermOption"
                                        class="ml-2"
                                    >
                                        <v-icon small left>mdi-plus</v-icon>
                                        Nova Opção
                                    </v-btn>
                                </div>

                                <!-- Lista de Opções -->
                                <div v-for="(option, index) in localModel.term_options" :key="index" class="mb-2">
                                    <v-card outlined class="pa-3" :class="getOptionCardClass(option)">
                                        <v-row no-gutters align="center">
                                            <!-- Número da opção -->
                                            <v-col cols="auto" class="mr-3">
                                                <v-avatar 
                                                    size="28" 
                                                    :color="getOptionAvatarColor(option)"
                                                    class="white--text caption font-weight-bold"
                                                >
                                                    {{ index + 1 }}
                                                </v-avatar>
                                            </v-col>
                                            
                                            <!-- Campo de texto do rótulo -->
                                            <v-col cols="12" sm="5" class="pr-2">
                                                <v-text-field
                                                    v-model="option.label"
                                                    label="Texto da opção"
                                                    placeholder="Ex: Li e concordo com os termos"
                                                    persistent-placeholder
                                                    dense
                                                    outlined
                                                    hide-details="auto"
                                                    :rules="[v => !!v || 'Obrigatório']"
                                                    :error="!!(errors['term_options.' + index + '.label'])"
                                                    :error-messages="errors['term_options.' + index + '.label']"
                                                />
                                            </v-col>
                                            
                                            <!-- Configurações da opção -->
                                            <v-col cols="12" sm class="d-flex align-center flex-wrap">
                                                <!-- Tipo de resposta: Aceite / Não Aceite -->
                                                <v-btn-toggle
                                                    v-model="option.acceptance_type"
                                                    mandatory
                                                    dense
                                                    class="mr-3 mb-1"
                                                >
                                                    <v-tooltip bottom>
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <v-btn 
                                                                x-small
                                                                :color="option.acceptance_type === 'accept' ? 'teal' : ''"
                                                                :dark="option.acceptance_type === 'accept'"
                                                                value="accept"
                                                                v-bind="attrs"
                                                                v-on="on"
                                                            >
                                                                <v-icon x-small left>mdi-check-circle</v-icon>
                                                                Aceite
                                                            </v-btn>
                                                        </template>
                                                        <span>Representa concordância (status "Assinado")</span>
                                                    </v-tooltip>
                                                    <v-tooltip bottom>
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <v-btn 
                                                                x-small
                                                                :color="option.acceptance_type === 'reject' ? 'blue-grey darken-1' : ''"
                                                                :dark="option.acceptance_type === 'reject'"
                                                                value="reject"
                                                                v-bind="attrs"
                                                                v-on="on"
                                                            >
                                                                <v-icon x-small left>mdi-close-circle</v-icon>
                                                                Não Aceite
                                                            </v-btn>
                                                        </template>
                                                        <span>Representa recusa (status "Recusado")</span>
                                                    </v-tooltip>
                                                </v-btn-toggle>

                                                <!-- Exigir justificativa -->
                                                <v-tooltip bottom>
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-chip
                                                            :color="option.require_justification ? 'amber darken-2' : 'grey lighten-3'"
                                                            :text-color="option.require_justification ? 'white' : 'grey darken-1'"
                                                            small
                                                            class="mr-2 mb-1"
                                                            @click="option.require_justification = !option.require_justification"
                                                            v-bind="attrs"
                                                            v-on="on"
                                                        >
                                                            <v-icon x-small left>{{ option.require_justification ? 'mdi-text-box-check' : 'mdi-text-box-outline' }}</v-icon>
                                                            Justificativa
                                                        </v-chip>
                                                    </template>
                                                    <span>
                                                        <strong>Exigir Justificativa:</strong> Quando ativado, o usuário<br>
                                                        deverá informar o motivo ao selecionar esta opção
                                                    </span>
                                                </v-tooltip>
                                            </v-col>
                                            
                                            <!-- Botão remover -->
                                            <v-col cols="auto">
                                                <v-tooltip bottom>
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-btn
                                                            icon
                                                            small
                                                            :disabled="localModel.term_options.length <= 1"
                                                            @click="removeTermOption(index)"
                                                            v-bind="attrs"
                                                            v-on="on"
                                                        >
                                                            <v-icon small :color="localModel.term_options.length <= 1 ? 'grey lighten-1' : 'error'">mdi-delete-outline</v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <span>Remover esta opção</span>
                                                </v-tooltip>
                                            </v-col>
                                        </v-row>
                                    </v-card>
                                </div>

                                <!-- Alerta se não houver opção de aceite ou não aceite -->
                                <v-alert 
                                    v-if="localModel.term_options && localModel.term_options.length > 0 && !hasValidAcceptanceOption"
                                    type="info" 
                                    dense 
                                    text
                                    class="ma-0 mt-2"
                                >
                                    <v-icon small left color="info">mdi-information</v-icon>
                                    <strong>Dica:</strong> Defina pelo menos uma opção como "Aceite" para identificar qual resposta representa concordância.
                                </v-alert>

                                <!-- Legenda -->
                                <div class="mt-3 d-flex align-center flex-wrap">
                                    <span class="caption grey--text mr-3">Legenda:</span>
                                    <v-chip x-small color="teal" text-color="white" class="mr-2">
                                        <v-icon x-small left>mdi-check-circle</v-icon>
                                        Aceite
                                    </v-chip>
                                    <span class="caption grey--text text--darken-1 mr-3">= Concordância</span>
                                    <v-chip x-small color="blue-grey darken-1" text-color="white" class="mr-2">
                                        <v-icon x-small left>mdi-close-circle</v-icon>
                                        Não Aceite
                                    </v-chip>
                                    <span class="caption grey--text text--darken-1 mr-3">= Recusa</span>
                                    <v-chip x-small color="amber darken-2" text-color="white" class="mr-2">
                                        <v-icon x-small left>mdi-text-box-check</v-icon>
                                        Justificativa
                                    </v-chip>
                                    <span class="caption grey--text text--darken-1">= Exige motivo/explicação</span>
                                </div>
                            </v-card>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" sm="12">
                            <span :class="{ 'error--text': !!errors.content }">Conteúdo*</span>
                                
                                <div :class="{ 'editor-error': !!errors.content }">
                                    <vue-editor 
                                        v-model="localModel.content"
                                        @selection-change="range = $event"
                                        ref="editor"
                                        :editorToolbar="customToolbar" 
                                    />
                                </div>
                                <div v-if="errors.content" class="v-messages error--text mt-1">
                                    <div class="v-messages__message">{{ Array.isArray(errors.content) ? errors.content[0] : errors.content }}</div>
                                </div>
                            
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" sm="4">
                            <s-switch inset text-helper="Obrigatório concordar para avançar no cadastro" v-model="localModel.is_required" label="Obrigatório"/>
                        </v-col>
                        <v-col cols="12" sm="4" v-if="localModel.is_required">
                            <s-switch inset text-helper="Bloqueia o acesso ao Sistema até a assinatura" v-model="localModel.block_profile" label="Bloquear acesso ao Sistema"/>
                        </v-col>
                        <!-- <v-col cols="12" sm="4">
                            <s-switch inset text-helper="Exibir concordância com o termo no Extrato do Professor" v-model="model.include_extract" label="Incluir Extrato"/>
                        </v-col> -->
                        <v-col cols="12" sm="4">
                            <s-switch inset text-helper="Enviar e-mail para o usuário com cópia do termo" v-model="localModel.send_email" label="Enviar E-mail"/>
                        </v-col>
                        <v-col cols="12" sm="4">
                            <s-switch inset text-helper="Salvar cópia do termo em PDF no Servidor" v-model="localModel.save_pdf" label="Salvar PDF"/>
                        </v-col>
                    </v-row>

                    <!-- Provider de Assinatura Digital (B4 / GOV.br) -->
                    <v-row v-if="localModel.save_pdf">
                        <v-col cols="12" sm="6">
                            <v-select
                                v-model="localModel.signature_provider"
                                :items="signatureProviderItems"
                                item-text="text"
                                item-value="value"
                                label="Provedor de Assinatura Digital"
                                hint="Assinatura Digital para assinatura qualificada; Interna apenas aceita no sistema"
                                persistent-hint
                                outlined
                                dense
                                clearable
                            />
                        </v-col>
                    </v-row>

                    <!-- Configuração de Comunicação - RN01 -->
                    <v-row v-if="localModel.send_email">
                        <v-col cols="12">
                            <v-divider class="my-2"></v-divider>
                            <span class="subtitle-2 grey--text text--darken-1">
                                <v-icon small class="mr-1">mdi-email-edit-outline</v-icon>
                                Configuração do E-mail de Comunicação
                            </span>
                        </v-col>
                    </v-row>
                    <v-row v-if="localModel.send_email">
                        <v-col cols="12">
                            <v-text-field
                                v-model="localModel.email_subject"
                                label="Assunto do E-mail"
                                :error="!!errors.email_subject"
                                :error-messages="errors.email_subject"
                                placeholder="Ex: Termo de Aceite de Carga Horária"
                                persistent-placeholder
                                hint="Assunto que aparecerá no e-mail enviado ao professor"
                                :counter="255"
                                :rules="[v => (!v || v.length <= 255) || 'Máximo de 255 caracteres atingido']"
                            />
                        </v-col>
                    </v-row>
                    <v-row v-if="localModel.send_email">
                        <v-col cols="12">
                            <span class="caption grey--text">Corpo do E-mail</span>
                            <vue-editor
                                v-model="localModel.email_body"
                                ref="emailEditor"
                                :editorToolbar="customToolbar"
                                placeholder="Texto personalizado do e-mail. Tags disponíveis: [[NOME_PROFESSOR]], [[NOME_TERMO]], [[LINK_ASSINATURA]]"
                            />
                            <span class="caption grey--text">
                                Use o botão <v-icon x-small>mdi-tag-plus-outline</v-icon> no cabeçalho ou Ctrl+Shift+T para inserir tags
                            </span>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="12" sm="4">
                            <v-switch color="purple" inset v-model="localModel.active" label="Ativo"></v-switch>
                        </v-col>
                    </v-row>
            </v-container>
            <!-- Alert para mensagens -->
            <emc-alert-snackbar :show="!! message.length"  :message="message" :color="error ? 'error' : 'success'"/>
        </template>
    </sys-register-base>
</template>

<script>

import { mapActions, mapState } from 'vuex'
export default {
    name: "SysRegisterTerm",
    data: () => ({
        localModel: {},
        viewMenu: false,
        dialog: false,
        error: false,
        errors: {},
        range: null,
        message: '',
        loading: false,
        tags: [],
        emailTags: [
            { tag: 'NOME_PROFESSOR', description: 'Nome do professor' },
            { tag: 'NOME_TERMO', description: 'Nome do termo' },
            { tag: 'LINK_ASSINATURA', description: 'Link para assinatura' }
        ],
        signatureProviders: {},
        customToolbar: [

                [{ header: [false, 1, 2, 3, 4, 5, 6] }],

                [{ size: ["small", false, "large", "huge"] }],

                ["bold", "italic", "underline"],

                [
                    { align: "" },
                    { align: "center" },
                    { align: "right" },
                    { align: "justify" }
                ],

                ["blockquote"],

                [{ list: "ordered" }, { list: "bullet" }],

                [{ indent: "-1" }, { indent: "+1" }],

                [{ color: [] }],

                ["link"],
                
        ]
        
    }),
    created() {
        this.loadTags();
        this.loadSignatureProviders();
        this._tagKeyHandler = (e) => {
            if (e.ctrlKey && e.shiftKey && e.key === 'T') {
                if (this.dialog && this.localModel) {
                    e.preventDefault();
                    this.viewMenu = true;
                }
            }
        };
    },
    mounted() {
        document.addEventListener('keydown', this._tagKeyHandler);
    },
    beforeDestroy() {
        document.removeEventListener('keydown', this._tagKeyHandler);
    },

    computed: {
      ...mapState('auth', ['acesso']),

      signatureProviderItems() {
        const providers = this.signatureProviders;
        return Object.entries(providers).map(([value, text]) => ({ value, text }));
      },
      
      /**
       * Verifica se existe pelo menos uma opção marcada como aceite válido
       * RN02: O administrador deve sinalizar qual opção representa concordância
       */
      hasValidAcceptanceOption() {
          if (!this.localModel.term_options || this.localModel.term_options.length === 0) {
              return true;
          }
          return this.localModel.term_options.some(opt => opt.acceptance_type === 'accept');
      }
    },

    watch: {
        
        dialog(dialog_new, dialog_old) {
            
            if(dialog_new !== dialog_old) {
                this.$emit('update:show', dialog_new)
            }

        },

        model: {
            immediate: true,
            handler(val) {
                if (val) {
                    this.localModel = structuredClone(val);
                }
            }
        },

        show(show_new, show_old) {
            
            this.dialog = show_new;
            
            if(show_new){
                
                this.error = false;
                this.errors = {};
                this.range = null;

                if (this.localModel.id) {
                    // Edição: carregar opções da API (term_options ou termOptions - camelCase/snake_case)
                    const optionsFromApi = this.localModel.term_options || this.localModel.termOptions;
                    if (optionsFromApi && Array.isArray(optionsFromApi) && optionsFromApi.length > 0) {
                        this.$set(this.localModel, 'term_options', optionsFromApi.map(opt => ({
                            id: opt.id,
                            label: opt.label || '',
                            code: opt.code,
                            color: opt.color,
                            icon: opt.icon,
                            description: opt.description,
                            acceptance_type: this.getAcceptanceTypeFromApi(opt),
                            require_justification: !!opt.require_justification,
                            active: opt.active !== false
                        })));
                    } else {
                        this.$set(this.localModel, 'term_options', []);
                    }
                    // Fallback: se não há opções mas há label legado, criar opção a partir dele
                    if (this.localModel.term_options.length === 0 && this.localModel.label) {
                        this.$set(this.localModel, 'term_options', [
                            { label: this.localModel.label, acceptance_type: 'accept', require_justification: false }
                        ]);
                    }
                } else {
                    // Novo registro: inicializar com valores padrão
                    this.$set(this.localModel, 'is_required', true);
                    this.$set(this.localModel, 'send_email', true);
                    this.$set(this.localModel, 'active', true);
                    this.$set(this.localModel, 'email_subject', '');
                    this.$set(this.localModel, 'email_body', '');
                    // RN01: Inicializar com opções padrão (Aceite e Não Aceite)
                    this.$set(this.localModel, 'term_options', [
                        { label: 'Li e concordo com os termos', acceptance_type: 'accept', require_justification: false },
                        { label: 'Não concordo com os termos', acceptance_type: 'reject', require_justification: true }
                    ]);
                }

            }
        },
        
    },
    props: {
        model: {
            default: null
        },
        color: {
            type: String,
            default: 'grey lighten-5'
        },
        width: {
            type: String,
            default: "500"
        },
        maxWidth: {
            type: String,
            default: "80%"
        },
        icon: {
            type: String,
            default: "mdi-database-plus"
        },
        title: {
            type: String,
            default: "Cadastro de Termo"
        },
        text: {
            type: String,
            default: ""
        },
        show: {
            type: Boolean,
            default: false
        }
    },
    methods:{
        ...mapActions('term', ['ActionIndexTermTags', 'ActionUpdateTerm', 'ActionCreateTerm', 'ActionGetSignatureProviders']),

        loadTags() {
            this.tags = [];

            this.ActionIndexTermTags({ column_order: 'tag', find_columns: { active: 1 } })
                .then((res) => {
                    this.tags = res.data;
                })
                .catch(() => {});
        },

        loadSignatureProviders() {
            this.ActionGetSignatureProviders()
                .then((res) => {
                    this.signatureProviders = res.data || res;
                })
                .catch(() => {
                    this.signatureProviders = {};
                });
        },
        
        getPlainText(html) {
            if (!html) return '';
            const div = document.createElement('div');
            div.innerHTML = html;
            return (div.textContent || div.innerText || '').trim();
        },

        validate() {
            this.errors = {};

            const name = (this.localModel.name || '').trim();
            if (!name) {
                this.errors.name = ['O campo nome é obrigatório.'];
            } else if (name.length > 255) {
                this.errors.name = ['O nome não pode ter mais de 255 caracteres.'];
            }

            const description = (this.localModel.description || '').trim();
            if (!description) {
                this.errors.description = ['O campo descrição é obrigatório.'];
            } else if (description.length > 255) {
                this.errors.description = ['A descrição não pode ter mais de 255 caracteres.'];
            }

            const contentText = this.getPlainText(this.localModel.content);
            if (!contentText) {
                this.errors.content = ['O campo conteúdo é obrigatório.'];
            } else if (contentText.length < 15) {
                this.errors.content = ['O conteúdo deve ter pelo menos 15 caracteres.'];
            }

            if (this.localModel.term_options && this.localModel.term_options.length > 0) {
                this.localModel.term_options.forEach((opt, index) => {
                    if (!opt.label || !opt.label.trim()) {
                        this.errors['term_options.' + index + '.label'] = ['O rótulo é obrigatório para cada opção de resposta.'];
                    }
                });
            }

            return Object.keys(this.errors).length === 0;
        },

        save()
        {
            this.error = false;
            this.message = '';

            if (!this.validate()) {
                this.error = true;
                this.message = 'Preencha os campos obrigatórios antes de salvar.';
                return;
            }

            this.loading = true;

            Object.assign(this.localModel, {institution_id: this.acesso.instituicao.id})

            // Converter acceptance_type para is_valid_acceptance antes de enviar à API
            if (this.localModel.term_options && this.localModel.term_options.length > 0) {
                this.localModel.term_options = this.localModel.term_options.map(opt => ({
                    ...opt,
                    is_valid_acceptance: opt.acceptance_type === 'accept'
                }));
                // Manter label sincronizado com a primeira opção de aceite para retrocompatibilidade
                const firstValidOption = this.localModel.term_options.find(opt => opt.is_valid_acceptance) || this.localModel.term_options[0];
                this.localModel.label = firstValidOption.label || '';
            }

            const isEdit = !!this.localModel.id;
            const action = isEdit ? this.ActionUpdateTerm : this.ActionCreateTerm;

            action(this.localModel)
                .then((res) => {
                    const msg = res.message;
                    this.message = (typeof msg === 'object' && msg !== null) ? (msg.success || msg.message || '') : (msg || '');
                    this.$emit('onCompleted', res.data);
                })
                .catch((error) => {
                    this.error = true;
                    this.errors = error.errors || {};
                    this.message = error.message || 'Erro ao salvar o termo.';
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        setField(tag) {
            const quill = this.$refs.editor?.quill;
            if (!quill) return;

            let range = quill.selection?.savedRange;
            if (!range) {
                const sel = quill.getSelection(true);
                range = sel ? { index: sel.index, length: sel.length } : { index: quill.getLength(), length: 0 };
            }

            const text = ' [[' + tag.tag + ']]';
            quill.insertText(range.index, text);
            this.localModel.content = quill.root.innerHTML;
            quill.setSelection(range.index + text.length);
            quill.focus();
            this.viewMenu = false;
        },

        setEmailField(tag) {
            const editor = this.$refs.emailEditor;
            if (!editor || !editor.quill) return;

            const range = editor.quill.getSelection(true) || { index: editor.quill.getLength(), length: 0 };
            const text = ' [[' + tag.tag + ']]';
            editor.quill.insertText(range.index, text);
            editor.quill.setSelection(range.index + text.length);
            editor.quill.focus();
            this.viewMenu = false;
        },

        /**
         * Adiciona uma nova opção de resposta
         * RN01: Múltiplas opções de resposta por termo
         */
        addTermOption() {
            if (!this.localModel.term_options) {
                this.$set(this.localModel, 'term_options', []);
            }
            const newOption = {
                label: '',
                acceptance_type: 'accept',
                require_justification: false
            };
            this.localModel.term_options.splice(this.localModel.term_options.length, 0, newOption);
        },

        /**
         * Remove uma opção de resposta
         * Deve haver pelo menos uma opção
         */
        removeTermOption(index) {
            if (this.localModel.term_options.length > 1) {
                this.localModel.term_options.splice(index, 1);
            }
        },

        /**
         * Retorna a classe CSS do card baseado no tipo de aceitação
         */
        getOptionCardClass(option) {
            if (option.acceptance_type === 'accept') return 'border-success';
            if (option.acceptance_type === 'reject') return 'border-error';
            return '';
        },

        /**
         * Retorna a cor do avatar baseado no tipo de aceitação
         */
        getOptionAvatarColor(option) {
            if (option.acceptance_type === 'accept') return 'success';
            if (option.acceptance_type === 'reject') return 'error';
            return 'grey lighten-1';
        },

        /**
         * Converte dados da API para acceptance_type
         * Retrocompatibilidade com is_valid_acceptance
         */
        getAcceptanceTypeFromApi(opt) {
            if (opt.acceptance_type) return opt.acceptance_type;
            return opt.is_valid_acceptance ? 'accept' : 'reject';
        }

    }
}
</script>

<style scoped>
.border-success {
    border-color: #4CAF50 !important;
    border-width: 2px !important;
}

.border-error {
    border-color: #ff5252 !important;
    border-width: 2px !important;
}

.editor-error :deep(.quillWrapper) {
    border: 2px solid #ff5252 !important;
    border-radius: 4px;
}

.editor-error :deep(.ql-toolbar) {
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
}

.editor-error :deep(.ql-container) {
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
}
</style>